var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/BimEntity/BimStandardSize.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { Id } from '../Id';
import { Version } from '../Version';
import { ApiDomain } from '../domain';
import { BimElement } from './BimElement';
import { ForgeRefs } from './ForgeRefs';
import { BimModelElementSource } from './BimModelElementSource';
import { ViewerRefs } from './ViewerRefs';
export var BimStandardSize;

(function (_BimStandardSize) {
  var domain = ApiDomain.domain('BimStandardSize', {
    name: "domain",
    sid: "-gpzy2r"
  });
  var io = _BimStandardSize.io = t.type({
    type: t.literal('BimStandardSize'),
    id: Id,
    name: t.string,
    total: t.number,
    forgeRefs: ForgeRefs,
    viewerRefs: ViewerRefs,
    modelId: Id,
    modelVersion: Version,
    source: BimModelElementSource,
    familyId: Id,
    isGenerated: t["boolean"]
  }, 'BimStandardSize');

  var is = _BimStandardSize.is = function (entity) {
    return entity.type === 'BimStandardSize';
  };

  var Populated;

  (function (_Populated) {
    var io = _Populated.io = t.type({
      type: t.literal('BimStandardSizePopulated'),
      id: Id,
      name: t.string,
      total: t.number,
      forgeRefs: ForgeRefs,
      viewerRefs: ViewerRefs,
      modelId: Id,
      modelVersion: Version,
      children: t.readonlyArray(BimElement.io),
      offset: t.number,
      source: BimModelElementSource,
      familyId: Id,
      isGenerated: t["boolean"]
    }, 'BimStandardSizePopulated');

    var is = _Populated.is = function (entity) {
      return entity.type === 'BimStandardSizePopulated';
    };

    var fetch = _Populated.fetch = ApiCallService.create({
      name: 'fetch',
      parentDomain: domain,
      result: Populated.io,
      getKey: ['key']
    });
  })(Populated || (Populated = _BimStandardSize.Populated || (_BimStandardSize.Populated = {})));
})(BimStandardSize || (BimStandardSize = {}));